module.exports = __webpack_public_path__ + "img/brunei.b1b88485.png";